import { HONEYPOT_FIELD } from '@/lib/formSubmit';

interface Props {
  value: string;
  onChange: (value: string) => void;
  idPrefix: string;
}

/**
 * Champ leurre anti-robot. Invisible et hors du flux de tabulation pour les
 * utilisateurs, mais rempli par la plupart des robots de spam. Le serveur
 * rejette silencieusement toute soumission dont ce champ n'est pas vide.
 */
const HoneypotField = ({ value, onChange, idPrefix }: Props) => (
  <div aria-hidden="true" className="absolute left-[-9999px] top-auto h-px w-px overflow-hidden">
    <label htmlFor={`${idPrefix}-${HONEYPOT_FIELD}`}>Site web</label>
    <input
      id={`${idPrefix}-${HONEYPOT_FIELD}`}
      name={HONEYPOT_FIELD}
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default HoneypotField;
